module.exports = __webpack_public_path__ + "img/appIcon-apps--PricingPage.4b84250a.svg";